import { useNavigate } from 'react-router-dom';

import Button from '@/components/ui/buttons/Button';

import styles from './ErrorContent.module.scss';

interface Props {
  image?: string;
  title?: string;
  subtitle?: string;
  description: string;
  buttons?: React.ReactElement[];
}

const ErrorContent: React.FC<Props> = ({
  image,
  title,
  subtitle,
  description,
  buttons,
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {image && (
          <div className={styles.imgContainer}>
            <img src={image} alt={title} className={styles.img} />
          </div>
        )}
        {title && <h2 className={styles.title}>{title}</h2>}
        {subtitle && <h3 className={styles.subtitle}>{subtitle}</h3>}
        <p className={styles.description}>{description}</p>
        <div className={styles.buttonContainer}>
          {buttons ? (
            buttons.map((button) => button)
          ) : (
            <Button
              onClick={() => {
                navigate('/login');
              }}
            >
              ホームに戻る
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorContent;
